"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PoiMarker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _map = require("@nicbase/map");

var _mapping = require("@nicbase/mapping");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PoiMarker = function PoiMarker(_ref) {
  var geometry = _ref.geometry,
      lat = _ref.lat,
      lng = _ref.lng,
      icon = _ref.icon,
      onMarkerClick = _ref.onMarkerClick;
  var Icon = (0, _mapping.getPoiCategoryIcon)(icon);

  var featureCollection = function featureCollection(item) {
    if (item.properties.geometry.type === 'Point' && item.properties.radius) {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: item.geometry.coordinates
        },
        properties: {
          radius: item.properties.radius
        }
      };
    }

    return item.properties;
  };

  var memorizedFeatureCollection = (0, _react.useMemo)(function () {
    return featureCollection(geometry);
  }, [geometry]);
  return /*#__PURE__*/_react["default"].createElement(_map.Marker, {
    lat: lat,
    lng: lng
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    onClick: function onClick() {
      return onMarkerClick({
        lat: lat,
        lng: lng
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_map.GeoJson, {
    feature: memorizedFeatureCollection
  }));
};

exports.PoiMarker = PoiMarker;

var noop = function noop() {};

PoiMarker.propTypes = {
  icon: _propTypes["default"].string,
  geometry: _propTypes["default"].shape({
    properties: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      waypointType: _propTypes["default"].string
    })
  }).isRequired,
  lat: _propTypes["default"].number.isRequired,
  lng: _propTypes["default"].number.isRequired,
  onMarkerClick: _propTypes["default"].func
};
PoiMarker.defaultProps = {
  icon: null,
  onMarkerClick: noop
};
var _default = PoiMarker;
exports["default"] = _default;